import { formatToLongDate } from "../../../utils/common";

/** List API returns "Unassigned"; detail API may return [] or locker objects */
export function parseVirtualLockers(virtual_lockers) {
  if (typeof virtual_lockers === "string") {
    return {
      isUnassigned: true,
      label: virtual_lockers,
      lockers: [],
    };
  }
  if (!Array.isArray(virtual_lockers) || virtual_lockers.length === 0) {
    return {
      isUnassigned: true,
      label: "Unassigned",
      lockers: [],
    };
  }
  return {
    isUnassigned: false,
    label: null,
    lockers: virtual_lockers,
  };
}

export function formatLockerIds(lockers) {
  if (!Array.isArray(lockers) || lockers.length === 0) return "Unassigned";
  return lockers
    .map((l) => l?.locker_id)
    .filter(Boolean)
    .join(", ");
}

export function formatPersonName(value) {
  if (value == null || String(value).trim() === "") return null;
  return String(value)
    .trim()
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function resolveDisplayName(customer) {
  if (!customer) return "—";
  if (customer.name?.trim()) return customer.name.trim();
  const parts = [customer.first_name, customer.last_name].filter(Boolean).join(" ").trim();
  return parts || "—";
}

export function resolveFormattedDisplayName(customer) {
  const name = resolveDisplayName(customer);
  if (name === "—") return name;
  return formatPersonName(name) || name;
}

export function formatBooleanLabel(value, { trueLabel, falseLabel }) {
  return value ? trueLabel : falseLabel;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const long = formatToLongDate(iso);
  if (long) return long;
  try {
    return new Date(iso).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function formatAddressTypeLabel(type) {
  if (!type) return "Address";
  const normalized = String(type).replace(/_/g, " ");
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}
